'use client'
import styled from "styled-components";
import {Col, Container, Row} from "react-bootstrap";
import {Img} from "@/components/common/ui/images/Img";
import Button from "@/components/common/ui/buttons/Button";

const ErrorPage = () => {

    return (
        <StyledErrorPage data-scroll-section className='StyledErrorPage'>
            <Img src={"/images/static/why.jpg"}/>
            <Container>
                <Row>
                    <Col sm={12} className={'text-center d-flex align-items-center justify-content-center flex-column gap-3'}>
                        <h3>Page not found </h3>
                        <Button src={"/"} text="Return Home"/>
                    </Col>
                </Row>
            </Container>
        </StyledErrorPage>
    );
};

const StyledErrorPage = styled.div `
    background: #e9e9e9;
    position: relative;
    overflow: hidden;
    padding: 200px 0;
    .container {
        position: relative;
        z-index: 4;
        h3 {
            color: white;

        }
    }
`;
export default ErrorPage;
